import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getSellerList, createSeller, updateSeller, deleteSeller } from '@/api/bairun/bianlidian'; //  此处请自行替换地址

import { getStationBaseInfoList } from '@/api/bairun/stationBaseInfo';
import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';
import { mapGetters } from "vuex";

var _this;

export default {
  name: 'BianlidianSeller',
  mixins: [infoList],
  computed: _objectSpread({}, mapGetters('user', ['userInfo', 'token'])),
  data: function data() {
    return {
      listApi: getSellerList,
      type: '',
      dialogVisible: false,
      stationOptions: [],
      selStationId: '',
      formData: {
        sellerId: 0,
        sellerName: '',
        sellerAddr: '',
        sellerCategory: 1,
        remark: ''
      },
      rules: {
        sellerName: [{
          required: true,
          message: '请输入便利店名称',
          trigger: 'blur'
        }],
        sellerAddr: [{
          required: true,
          message: '请输入便利店地址',
          trigger: 'blur'
        }]
      }
    };
  },
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? '是' : '否';
      } else {
        return '';
      }
    },
    getStationName: function getStationName(id) {
      for (var i = 0; i < _this.stationOptions.length; i++) {
        if (_this.stationOptions[i].ID === id) {
          return _this.stationOptions[i].stationName;
        }
      }

      return '';
    },
    getStationOption: function getStationOption(id) {
      for (var i = 0; i < _this.stationOptions.length; i++) {
        if (_this.stationOptions[i].ID === id) {
          return _this.stationOptions[i];
        }
      }

      return null;
    }
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log('created');

              _this2.init();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    init: function init() {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var stationOptions;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log('seller init');
                _context2.next = 3;
                return getStationBaseInfoList({
                  page: 1,
                  pageSize: 999999,
                  donNotShowLoading: true
                });

              case 3:
                stationOptions = _context2.sent;
                _this.stationOptions = stationOptions.data.list;

                _this.getTableData();

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    // 条件搜索前端看此方法
    onSubmit: function onSubmit() {
      this.page = 1;
      this.pageSize = 10;
      this.getTableData();
    },
    onReset: function onReset() {
      this.searchInfo = {};
      this.onSubmit();
    },
    onStationChange: function onStationChange() {
      var that = this;

      if (that.selStationId) {
        that.formData.sellerId = that.selStationId;
        that.formData.sellerName = that.$options.filters.getStationOption(that.selStationId).stationName;
        that.formData.sellerAddr = that.$options.filters.getStationOption(that.selStationId).stationAddress;
      } else {
        that.formData.sellerId = 0;
        that.formData.sellerName = '';
        that.formData.sellerAddr = '';
      }
    },
    onAdd: function onAdd() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var that;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                that = _this3;
                that.type = 'add';
                that.dialogVisible = true;

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    onUpdate: function onUpdate(row) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var that;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                that = _this4;
                that.type = 'update';
                that.dialogVisible = true;
                that.formData = row;

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    onDel: function onDel(row) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var that;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                that = _this5;
                that.$confirm('确定要删除吗？', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(function () {
                  deleteSeller({
                    'sellerId': row.sellerId
                  }).then(function (res) {
                    if (res.code == 0) {
                      that.$message({
                        type: 'success',
                        message: res.msg
                      });
                      that.getTableData();
                    } // eslint-disable-next-line handle-callback-err

                  }, function (err) {});
                }).catch(function (err) {});

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    closeDialog: function closeDialog() {
      this.dialogVisible = false;
      this.selStationId = '';
      this.formData = {
        sellerId: 0,
        sellerName: '',
        sellerAddr: '',
        sellerCategory: 1,
        remark: ''
      };
    },
    enterDialog: function enterDialog() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var that;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                that = _this6; // eslint-disable-next-line eqeqeq

                if (that.type == 'add') {
                  that.$refs['formData'].validate(function (valid) {
                    // eslint-disable-next-line no-empty
                    if (valid) {
                      that.formData.sellerId = parseInt(that.formData.sellerId);
                      createSeller(that.formData).then(function (res) {
                        // eslint-disable-next-line eqeqeq
                        if (res.code == 0) {
                          that.$message({
                            type: 'success',
                            message: res.msg
                          });
                          that.closeDialog();
                          that.getTableData();
                        } // eslint-disable-next-line handle-callback-err

                      }, function (err) {});
                    } else {
                      return false;
                    }
                  });
                }

                if (that.type == 'update') {
                  that.$refs['formData'].validate(function (valid) {
                    // eslint-disable-next-line no-empty
                    if (valid) {
                      that.formData.sellerId = parseInt(that.formData.sellerId);
                      updateSeller(that.formData).then(function (res) {
                        // eslint-disable-next-line eqeqeq
                        if (res.code == 0) {
                          that.$message({
                            type: 'success',
                            message: res.msg
                          });
                          that.closeDialog();
                          that.getTableData();
                        } // eslint-disable-next-line handle-callback-err

                      }, function (err) {});
                    } else {
                      return false;
                    }
                  });
                }

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    }
  }
};